import { cacheDom } from "../utils/QuerySelectors.js"
import { addLineItems, changeLineItem } from "../utils/Cart.js"
import { getXgenProducts } from '../utils/Product.js'
import { showAlertMessage } from '../utils/helpers.js'

const dom = {}
const qs = {
  giftProduct: 'data-gift-product',
  giftWrapping: 'data-gift-wrapping',
  giftWrappingContent: 'data-gift-wrapping-content',
  giftNote: 'data-gift-note',
  cartSubmit: 'data-cart-submit',
  swiper: 'data-cart-swiper',
}
const qsAll = {
  actionButtons: 'data-cart-action',
}
const truncateGiftNote = (e) => {
  const lettersLength = e.target.value.trim().length
  const maxLength = 200
  if(lettersLength > 200) {
    let letters = e.target.value.trim()
    e.target.value = letters.slice(0, maxLength)
    showAlertMessage(window.statusMessageStrings.giftNoteLimit)
  }
}
const initSlider = () => {
  new Swiper(dom.swiper, {
    speed: 500,
    loop: true,
    spaceBetween: 16,
    slidesPerView: 3,
    breakpoints: {
      300: {
        slidesPerView: 2.3,
        spaceBetween: 8,
      },
      375: {
        slidesPerView: 2.3,
        spaceBetween: 12,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 16,
      }
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  })
}

export const setupCart = () => {
  cacheDom(dom, qs, qsAll)
  if(dom.giftProduct) {
    dom.giftProduct.addEventListener('input', (e) => {
      e.target.disabled = true
      if(e.target.checked) {
        addLineItems((cart) => {
          location.reload()
        }, [{quantity: 1, id: dom.giftProduct.value}], false)
      } else {
        changeLineItem((cart) => {
          location.reload()
        }, {quantity: 0, id: dom.giftProduct.value}, false)
      }
    })
  }
  if(dom.giftWrapping) {
    dom.giftWrapping.addEventListener('input', (e) => {
      dom.giftWrappingContent.classList.toggle('hidden', !e.target.checked)
      if(e.target.checked) dom.giftNote.focus()
    })
    dom.giftWrappingContent.classList.toggle('hidden', !dom.giftWrapping.checked)
    
    dom.giftNote.addEventListener('keypress', (e) => truncateGiftNote(e))
    dom.giftNote.addEventListener('change', (e) => truncateGiftNote(e))
  }
  if(dom.giftWrapping && dom.giftWrapping.checked && dom.giftNote.value.trim() == '') {
    dom.giftWrapping.value = ''
    dom.giftWrapping.checked = false
    dom.giftWrappingContent.classList.toggle('hidden', true)
  }
  if(dom.cartSubmit) {
    dom.cartSubmit.addEventListener('click', () => {
      dom.giftNote.value = dom.giftNote.value.trim()
      if(dom.giftWrapping && dom.giftWrapping.checked) {
        if(dom.giftNote.value.trim() == '') {
          dom.giftWrapping.checked = false
          dom.giftWrapping.value = ''
        } else
          dom.giftWrapping.value = 'yes'
      } else if(dom.giftWrapping && !dom.giftWrapping.checked && dom.giftNote.value.trim() != '') {
        dom.giftNote.value = ''
        dom.giftWrapping.checked = false
        dom.giftWrapping.value = ''
      }
    })
  }
  if(dom.swiper) {
    const xgenId = dom.swiper.dataset.xgen
    const excludeSale = dom.swiper.dataset.excludeSale
    if(xgenId) {
      if(typeof getXgenPredictions != 'undefined') {
        getXgenPredictions(xgenId).then((results) => {
          const skus = results.map((result) => result.variants[0].sku).filter(Boolean)
          getXgenProducts((results) => {
            console.log(results)
            const swiperWrapper = dom.swiper.querySelector('.swiper-wrapper')
            const filteredResults = (typeof excludeSale != 'undefined' && excludeSale == "true") ? results.filter((result) => !result.tags.includes('Sale') && !result.tags.includes('Final Sale')) : results
            filteredResults.forEach((result) => {
              result.showATC = true
              swiperWrapper.innerHTML +=  `
                <div class="swiper-slide">
                  <div class="h-full" product-tile props='${JSON.stringify(result).replaceAll("'", "’")}'></div>
                </div>
              `
            })
            window.setupProductTiles(swiperWrapper.querySelectorAll('[product-tile]:empty'))
            initSlider()
          }, skus)
        })
      }
    } else
      initSlider()
  }

  dom.actionButtons.forEach(actionButton => {
    actionButton.addEventListener('click', (e) => {
      e.preventDefault()
      localStorage.setItem('cartItemAction', actionButton.getAttribute(qsAll.actionButtons))
      localStorage.setItem('cartItemQuantity', actionButton.getAttribute('data-next-qty'))
      location.href = actionButton.href
    })
  })
  if(location.href.includes('/cart')) {
    const cartItemAction = localStorage.getItem('cartItemAction')
    const cartItemQty = localStorage.getItem('cartItemQuantity')
    if(!!cartItemAction) {
      if(cartItemAction == 'minus') {
        showAlertMessage(`${window.statusMessageStrings.cart.qtyDecreased} ${cartItemQty}`)
      } else if(cartItemAction == 'plus') {
        showAlertMessage(`${window.statusMessageStrings.cart.qtyIncreased} ${cartItemQty}`)
      } else {
        showAlertMessage(window.statusMessageStrings.cart.qtyRemoved)
      }
      localStorage.removeItem('cartItemAction')
      localStorage.removeItem('cartItemQuantity')
    }
  } else {
    localStorage.removeItem('cartItemAction')
    localStorage.removeItem('cartItemQuantity')
  }
}